import React, { useState, useEffect, useCallback } from "react";
import propTypes from "prop-types";

import { useLocation, Redirect, Route, generatePath } from "react-router-dom";
import { useAdmin } from "providers/AdminProvider/AdminProvider";

import tokenInfo from "api/tokenInfo";

import ErrorBoundary from "components/ErrorBoundary/ErrorBoundary";
import Loader from "components/Loader/Loader";
import Dashboard from "layouts/Dashboard/Dashboard";
import TabCleanser from "routes/TabCleanser";

import * as routes from "routes";

import StateHistory from "components/StateHistory";

const AdminRoute = ({ children, isPrivate, isGlobalAdmin, hideDashboard, ...props }) => {
  const location = useLocation();

  const { pathname, state: locState = {} } = location;

  const { redirect = routes.DASHBOARD, formData, message, sessionExpired } = locState;

  const { globalAdmin, token, setUser, setToken } = useAdmin();

  const [checking, setChecking] = useState(!process.env.REACT_APP_SKIP_TOKEN_CHECK);

  // todo - see if this really needs to be memoized, as it is in the Provider too
  const setUserCallback = useCallback((user) => {
    setUser(user);
  }, []);

  const checkToken = useCallback(async () => {
    try {
      const { data } = await tokenInfo();
      const user = (({ globalAdmin, enrolmentAdmin, instanceAdmin, email }) => ({
        globalAdmin,
        enrolmentAdmin,
        instanceAdmin,
        username: email,
      }))(data);
      setUserCallback(user);
      setToken(true);
    } catch (e) {
      setToken(false);
      setUserCallback(null);
    }
  }, [setUserCallback, pathname]);

  useEffect(() => {
    if (!process.env.REACT_APP_SKIP_TOKEN_CHECK) {
      setChecking(true);
      checkToken().then(() => {
        setChecking(false);
      });
    }
  }, [checkToken, token, pathname]);

  /**
   * private routes are wrapped in the dashboard if logged in
   * or redirected to the login page
   *
   * globalAdmin routes are redirect to the dashboard if user is not globalAdmin
   *
   * public routes are redirected to the dashboard if logged in
   */
  const output = checking ? (
    <Loader />
  ) : token ? (
    isPrivate && (!isGlobalAdmin || (isGlobalAdmin && globalAdmin)) ? (
      hideDashboard ? (
        children
      ) : (
        <Dashboard>
          <ErrorBoundary>{children}</ErrorBoundary>
        </Dashboard>
      )
    ) : (
      <Redirect
        to={{
          pathname: redirect ? redirect : routes.DASHBOARD,
          state: { formData, message },
        }}
      />
    )
  ) : isPrivate ? (
    <Redirect
      to={{
        pathname: generatePath(routes.LOGIN),
        state: { redirect: pathname, formData, sessionExpired, message },
      }}
    />
  ) : (
    children
  );

  /**
   * private routes are wrapped in the dashboard if logged in
   * or redirected to the login page
   *
   * globalAdmin routes are redirect to the dashboard if user is not globalAdmin
   *
   * public routes are redirected to the dashboard if logged in
   */
  // const output = (() => {
  //   if (checking) return <Loader />;
  //   if (token) {
  //     // isGlobalAdmin refers to route, globalAdmin refers to current user
  //     if (isPrivate && (!isGlobalAdmin || (isGlobalAdmin && globalAdmin))) {
  //       if (hideDashboard) return children;
  //       return <Dashboard>{children}</Dashboard>;
  //     }
  //     return (
  //       <Redirect to={{ pathname: redirect ?? routes.DASHBOARD, state: { formData, message } }} />
  //     );
  //   }
  //   if (isPrivate)
  //     return (
  //       <Redirect
  //         to={{
  //           pathname: routes.LOGIN,
  //           state: { redirect: pathname, formData, sessionExpired: true, message },
  //         }}
  //       />
  //     );
  //   return children;
  // })();

  return (
    <Route {...props}>
      <StateHistory />
      <TabCleanser>{output}</TabCleanser>
    </Route>
  );
};

AdminRoute.propTypes = {
  isPrivate: propTypes.bool,
  isGlobalAdmin: propTypes.bool,
};

AdminRoute.defaultProps = {
  isPrivate: false,
  isGlobalAdmin: false,
};

export default AdminRoute;
